export default __webpack_public_path__ + "static/media/jumping.a1ecf2c2.jpg";